export interface VCardContact {
  firstName: string;
  lastName: string;
  projectName: string;
  customerName: string;
  phoneNumber: string;
}

export interface ContactOpenActions {
  recordContactOpened: () => Promise<void>;
  downloadContact: (contents: string, filename: string) => void;
}

export function contactActionLabel(previouslyOpened: boolean): string {
  return previouslyOpened
    ? 'Actualizar contacto — guardado anteriormente'
    : 'Guardar contacto';
}

function escapeVCard(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/\r\n|\r|\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
}

export function createVCard(contact: VCardContact): string {
  const projectName = contact.projectName.trim();
  const formattedName = projectName
    ? `${contact.customerName} — ${projectName}`
    : contact.customerName;
  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${escapeVCard(contact.lastName)};${escapeVCard(contact.firstName)};${escapeVCard(projectName)};;`,
    `FN:${escapeVCard(formattedName)}`,
    `TEL;TYPE=CELL:${escapeVCard(contact.phoneNumber)}`,
    'END:VCARD',
    '',
  ].join('\r\n');
}

export async function openVCardContact(
  contact: VCardContact,
  actions: ContactOpenActions,
): Promise<{ trackingFailed: boolean }> {
  let trackingFailed = false;
  try {
    await actions.recordContactOpened();
  } catch {
    trackingFailed = true;
  }
  actions.downloadContact(
    createVCard(contact),
    `${contact.customerName || 'Contacto'}.vcf`,
  );
  return { trackingFailed };
}

export function downloadVCard(contents: string, filename: string): void {
  const blob = new Blob([contents], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.replace(/[\\/:*?"<>|]/g, '-');
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
